import * as React from 'react';
import cx from 'classnames';
import style from './Resources.css';
import shape from '_images/shape1.svg';
import YouTubeEmbed from 'react-youtube-embed';

import ModelingFrameworkPdf from './pdf/modeling-framework.pdf';
import ModelingFrameworkImg from './images/modeling-framework.jpg';

import Stochastic from './images/Stochastic.png';

import BlockDiagrams from './images/block_diagrams.png';
import ConstitutingAI from './images/constituting_ai.png';
import EthnographyOfDAOs from './images/ethnography_of_daos.png';
import DAOCybernetics from './images/cybernetics.png';
import CIC from './images/cic.png';
import ScalingGlobalCommons from './images/scaling-commons.png';
import Zine from './images/zine.png';
import Fungibility from './images/fungibility.png';
import GDS1 from './images/gds1.png';
import DigitalEthnography from './images/digitalethnography.png';

import FoundationsImg from './images/foundations.jpg';
import EconomicGamesImg from './images/Economic_Games.jpg';
import ConfigurationSpacesImg from './images/Configurations_spaces.jpg';

let WOW = function () {
};
if (typeof window !== 'undefined') {
    WOW = require('wowjs');
}

const Preview = (props) => (
    <a className={cx(style.preview, props.className)} target="_blank" href={props.href}>
        <img src={props.src} alt={props.alt}/>
    </a>
);

const YouTube = ({videoId, className}) => (
    <div className={className}>
        <YouTubeEmbed aspectRatio="60%" id={videoId}/>
    </div>
);

export class Resources extends React.Component {
    componentDidMount() {
        if (typeof window !== 'undefined') {
            let wow = new WOW({
                mobile: false,
                live: true,
                scrollContainer: null,
                offset: 80
            });
            wow.init();
        }
    }

    render() {
        return (
            <div className={style.root}>
                <header className={style.header}>
                    <img className={cx(style.shape, style.shape1, 'rotation fast')} src={shape}/>
                    <img className={cx(style.shape, style.shape2, 'rotation slower')} src={shape}/>
                    <img className={cx(style.shape, style.shape3, 'rotation fast')} src={shape}/>

                    <div className="container">
                        <h1 className={cx(style.title, 'wow', 'fadeInUp')}>Resources</h1>
                        <p className={cx(style.text, 'wow', 'fadeInUp')} data-wow-delay="0.25s">
                            We love to share our knowledge with the community. Below you can find our recent talks and presentations.
                            For more videos and content be sure to follow our <a href="https://www.youtube.com/c/BlockScience/">YouTube channel</a> and visit our <a href="https://blockscience.ghost.io/">blog on Ghost</a>.
                        </p>
                    </div>
                </header>
                <div className={style.content}>
                    <img className={cx(style.shape, style.shape4, 'rotation slower')} src={shape}/>
                    <img className={cx(style.shape, style.shape5, 'rotation faster')} src={shape}/>
                    <img className={cx(style.shape, style.shape6, 'rotation slow')} src={shape}/>
                    <img className={cx(style.shape, style.shape7, 'rotation slow')} src={shape}/>

                    <div className="container">
                        <h3 className={cx(style.resourceTitle, 'wow fadeInUp')} style={{marginBottom: '10px', marginTop:'100px'}}>Academic Papers & Publications</h3>
                        <div className={style.row} style={{ alignItems: "flex-start" }}>
                        <div className={style.rowItem3}>
                            <h5>Constituting an AI: Accountability Lessons from a LLM Experiment, 2023</h5>
                            <Preview
                                className="wow fadeInUp"
                                href={"https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4561433"}
                                src={ConstitutingAI}
                                alt={'Constituting an AI: Accountability Lessons from a LLM Experiment'}
                            />
                        </div>
                        <div className={style.rowItem3}>
                            <h5>Block Diagrams for Categorical Cybernetics, 2023</h5>
                            <Preview
                                className="wow fadeInUp"
                                href={"https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4569037"}
                                src={BlockDiagrams}
                                alt={'Block Diagrams for Categorical Cybernetics, 2023'}
                            />
                        </div>
                        <div className={style.rowItem3}>
                            <h5>The Ethnography of a 'Decentralized Autonomous Organization' (DAO): De-mystifying Algorithmic Systems, 2022</h5>
                            <Preview
                                className="wow fadeInUp"
                                href={"https://anthrosource.onlinelibrary.wiley.com/doi/abs/10.1111/epic.12104"}
                                src={EthnographyOfDAOs}
                                alt={'The Ethnography of a &#39;Decentralized Autonomous Organization&#39; (DAO): De-mystifying Algorithmic Systems'}
                            />
                        </div>
                        </div>
                        <div className={style.rowb}>
                        <div className={style.rowItem3}>
                                <h5>Generalized Dynamical Systems, 2022</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={"https://blockscience.ghost.io/generalized-dynamical-systems-part-i-foundations-2/"}
                                    src={GDS1}
                                    alt={'Generalized Dynamical Systems, 2022'}
                                />
                            </div>
                            <div className={style.rowItem3}>
                                <h5>Towards a participatory digital ethnography of blockchain governance, 2022</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={"https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4078259"}
                                    src={DigitalEthnography}
                                    alt={'Towards a participatory digital ethnography of blockchain governance, 2022'}
                                />
                            </div>
                            <div className={style.rowItem3}>
                                <h5>Complex Systems Modeling of Community Inclusion Currencies, 2022</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={"https://research.wu.ac.at/en/publications/complex-systems-modeling-of-community-inclusion-currencies"}
                                    src={CIC}
                                    alt={'Complex Systems Modeling of Community Inclusion Currencies, 2022'}
                                />
                            </div>
                            
                            
                        </div>
                        <div className={style.rowb}>
                            <div className={style.rowItem3}>
                                <h5>Navigating Information Infrastructure, 2022</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={"https://blockscience.ghost.io/nft-zine-explores-the-use-of-web3-for-funding-attribution-of-open-r-d/"}
                                    src={Zine}
                                    alt={'Navigating Information Infrastructure, 2022'}
                                />
                            </div> 
                            
                            
                            <div className={style.rowItem3}>
                                <h5>Aligning the concept of 'Decentralized Autonomous Organization' to Precedents in Cybernetics, 2022</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={"https://blockscience.ghost.io/aligning-the-concept-of-decentralized-autonomous-organization-to-precedents-in-cybernetics/"}
                                    src={DAOCybernetics}
                                    alt={"Aligning the concept of 'Decentralized Autonomous Organization' to Precedents in Cybernetics, 2022"}
                                />
                            </div> 
                            <div className={style.rowItem3}>
                                <h5>Challenges and Approaches to Scaling the Global Commons, 2021</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={"https://www.frontiersin.org/articles/10.3389/fbloc.2021.578721/full"}
                                    src={ScalingGlobalCommons}
                                    alt={'Challenges and Approaches to Scaling the Global Commons, 2021'}
                                />
                            </div> 
                        </div>
                        <div className={style.rowb}>
                            <div className={style.rowItem3}>
                                <h5>Economic Games as Estimators, 2020</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={"https://epub.wu.ac.at/7433/"}
                                    src={EconomicGamesImg}
                                    alt={'Economic Games as Estimators, 2020'}
                                />
                            </div>
                            <div className={style.rowItem3}>
                                <h5>On modeling blockchain-enabled economic networks as stochastic dynamical systems, 2019</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={"https://appliednetsci.springeropen.com/articles/10.1007/s41109-020-0254-9"}
                                    src={Stochastic}
                                    alt={'On modeling blockchain-enabled economic networks as stochastic dynamical systems, 2019'}
                                />
                            </div>
                            <div className={style.rowItem3}>
                                <h5>A State-Space Modeling Framework, 2018</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={ModelingFrameworkPdf}
                                    src={ModelingFrameworkImg}
                                    alt={'A State-Space Modeling Framework, 2018'}
                                />
                            </div> 
                        </div>
                        <div className={style.rowb}>
                            <div className={style.rowItem3}>
                                <h5>A Practical Theory of Fungibility, 2021</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={"https://s.mirror.xyz/wLE2_GhUvP9mxwWXVlcWwv9Wr-HxLMadoN5FbaqeQ9A"}
                                    src={Fungibility}
                                    alt={'A Practical Theory of Fungibility, 2021'}
                                />
                            </div>
                            <div className={style.rowItem3}>
                                <h5>From Curved Bonding to Configuration Spaces, 2019</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={"https://epub.wu.ac.at/7385/"}
                                    src={ConfigurationSpacesImg}
                                    alt={'From Curved Bonding to Configuration Spaces, 2019'}
                                />
                            </div>
                            <div className={style.rowItem3}>
                                <h5>Foundations of Cryptoeconomic Systems, 2019</h5>
                                <Preview
                                    className="wow fadeInUp"
                                    href={"https://epub.wu.ac.at/7309/"}
                                    src={FoundationsImg}
                                    alt={'Foundations of Cryptoeconomic Systems, 2019'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <h3 className={cx(style.resourceTitle, 'wow fadeInUp')} style={{marginBottom: '0px', marginTop:'100px'}}>Recent Talks</h3>
                        <p className={cx(style.articleLink, 'fadeInUp')} data-wow-delay="0.25s">
                        To see more talks and presentations, check out our <a href="https://www.youtube.com/c/BlockScience/" target="_blank">YouTube channel</a>.
                        </p>
                        <div className={style.row}>
                            <div className={style.rowItem3}>
                            <h5>Informing the Filecoin Launch through Cryptoeconomics and Simulations (Oct 2022)</h5>
                            <YouTube
                                className={cx(style.video, 'wow fadeInUp')}
                                videoId="kBzwgfnk91c"
                            />
                            </div>
                            <div className={style.rowItem3}>
                                <h5>Algorithms as Policy (June 2022)</h5>
                            <YouTube
                                className={cx(style.video, 'wow fadeInUp')}
                                videoId="pZI3v_L-xnA"
                            />
                            </div>
                            <div className={style.rowItem3}>
                            <h5>Foundations of Decentralized Governance (Nov 2021)</h5>
                            <YouTube
                                className={cx(style.video, 'wow fadeInUp')}
                                videoId="o8xrLw5uKyI"
                            />
                            </div>
                        </div>
                        <div className={style.row}>
                            <div className={style.rowItem3}>
                            <h5>Decentralized Organizations at Systems Innovation (Aug 2020)</h5>
                            <YouTube
                                className={cx(style.video, 'wow fadeInUp')}
                                videoId="P-5PITsn26g"
                            />
                            </div>
                            <div className={style.rowItem3}>
                            <h5>MIT's CryptoEconSys (Mar 2020)</h5>
                            <YouTube
                                className={cx(style.video, 'wow fadeInUp')}
                                videoId="HldQF_MJN_Y"
                            />
                            </div>
                            <div className={style.rowItem3}>
                            <h5>Odyssey Connect (Feb 2020)</h5>
                            <YouTube
                                className={cx(style.video, 'wow fadeInUp')}
                                videoId="xQuuQvEDwkY"
                            />
                            </div>
                        </div>

                        <div className={style.row} style={{ marginTop: '10px' }}>
                            
                            <div className={style.rowItem3}>
                            <h5>The Fields Institute (Nov 2019)</h5>
                            <YouTube
                                className={cx(style.video, 'wow fadeInUp')}
                                videoId="HvSdRgx2Z4M"
                            />
                            </div>
                            <div className={style.rowItem3}>
                            <h5>DAOfest Berlin (Sep 2019)</h5>
                            <YouTube
                                className={cx(style.video, 'wow fadeInUp')}
                                videoId="75769EjciVk"
                            />
                            </div>
                            <div className={style.rowItem3}>
                                <h5>Web3 Summit (Sep 2019)</h5>
                                <YouTube
                                    className={cx(style.video, 'wow fadeInUp')}
                                    videoId="IyNvoYuSFII"
                                />
                            </div>
                        </div>
                        <div className={style.row} style={{marginTop: '10px'}}>

                            <div className={style.rowItem3}>
                                <h5>TEGG in Berlin (Aug 2019)</h5>
                                <YouTube
                                    className={cx(style.video, 'wow fadeInUp')}
                                    videoId="xRqXAlpWl0Y"
                                />
                            </div>
                            <div className={style.rowItem3}>
                            <h5>Reward Mechanisms and the Engineering of Token Incentives (Aug 2019)</h5>
                            <YouTube
                                className={cx(style.video, 'wow fadeInUp')}
                                videoId="9C2xgMSi3Fs"
                            />
                            </div>
                            <div className={style.rowItem3}>
                            <h5>Creating Interconnected Collaborative Communities (Sept 2018)</h5>
                            <YouTube
                                className={cx(style.video, 'wow fadeInUp')}
                                videoId="nOP6anxiHkk"
                            />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <h3 className={cx(style.resourceTitle, 'wow fadeInUp')} style={{marginBottom: '10px', marginTop:'30px'}}>Podcasts</h3>
                        <div className={style.articleLinks}>
                            <ul className="wow fadeInUp">
                                <li><a className={style.articleLink} target="_blank"
                                       href="https://open.spotify.com/episode/67ZvNZMWJIFBI7y21bKaiC">
                                    Mint & Burn: Engineering Methods in Web3 w/ Danilo Lessa & Kelsie Nabben (June 2022)
                                </a></li>

                                <li><a className={style.articleLink} target="_blank"
                                       href="https://open.spotify.com/episode/5WYyYR8BzO9bHYRWqYU0vW">
                                    IEEE Blockchain: A Conversation w/ Michael Zargham (March 2022)
                                </a></li>

                                <li><a className={style.articleLink} target="_blank"
                                       href="https://open.spotify.com/episode/2r4ndpN1DdKbwkMf9dHhWF">
                                    Mint & Burn: Algorithms as Policy w/ Michael Zargham (Dec 2021)
                                </a></li>

                                <li><a className={style.articleLink} target="_blank"
                                       href="https://palladiummag.com/2021/08/04/palladium-podcast-62-michael-zargham-on-society-as-a-complex-system/">
                                    Palladium: Society As a Complex System w/ Michael Zargham (Aug 2021)
                                </a></li>

                                <li><a className={style.articleLink} target="_blank"
                                       href="https://www.youtube.com/watch?v=drHjjOYqQyA">
                                    The Future of Crypto w/ Michael Zargham (May 2021) 
                                </a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="container">
                        <h3 className={cx(style.resourceTitle, 'wow fadeInUp')} style={{marginBottom: '10px', marginTop:'30px'}}>Recommended Reading</h3>
                        <div className={style.articleLinks}>
                            <ul className="wow fadeInUp">
                                <li><a className={style.articleLink} target="_blank"
                                       href="https://mitpress.mit.edu/books/engineering-safer-world">
                                    Engineering a Safer World by Nancy G. Leveson
                                </a></li>

                                <li><a className={style.articleLink} target="_blank"
                                       href="https://www.goodreads.com/book/show/1117634.Small_Is_Beautiful">
                                    Small is Beautiful by E.F. Schumacher
                                </a></li>

                                <li><a className={style.articleLink} target="_blank"
                                       href="https://www.goodreads.com/en/book/show/44244975-the-ethical-algorithm">
                                    The Ethical Algorithm by Michael Kearns & Aaron Roth
                                </a></li>

                                <li><a className={style.articleLink} target="_blank"
                                       href="https://www.goodreads.com/book/show/530415.The_Art_of_Doing_Science_and_Engineering">
                                    The Art of Doing Science and Engineering: Learning to Learn by Richard Hamming
                                </a></li>

                                <li><a className={style.articleLink} target="_blank"
                                       href="https://www.goodreads.com/book/show/3828902-thinking-in-systems">
                                    Thinking in systems: A Primer by Donella Meadows
                                </a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}